<div class="alert-dialog" [ngClass]="'dialog-' + data.type">
  <div class="dialog-header">
    <mat-icon class="header-icon">{{ data.icon }}</mat-icon>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>

  <mat-dialog-content>
    <p class="dialog-message">{{ data.message }}</p>

    @if (data.copyableText) {
      <div class="copyable-field">
        <span class="copyable-label">{{ data.copyableLabel || 'Texto' }}</span>
        <div class="copyable-row">
          <span class="copyable-text" [class.masked]="!passwordVisible()">
            {{ passwordVisible() ? data.copyableText : getMaskedText() }}
          </span>
          <button mat-icon-button type="button" (click)="togglePasswordVisibility()"
                  matTooltip="{{ passwordVisible() ? 'Ocultar' : 'Mostrar' }}">
            <mat-icon>{{ passwordVisible() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <button mat-icon-button type="button" (click)="copyToClipboard()"
                  matTooltip="{{ copied() ? 'Copiado' : 'Copiar al portapapeles' }}">
            <mat-icon>{{ copied() ? 'check' : 'content_copy' }}</mat-icon>
          </button>
        </div>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-raised-button
            type="button"
            color="primary"
            (click)="onConfirm()"
            class="confirm-btn">
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>
